import api from './api';
import configPromise from 'config';
import AppError from 'utils/appError';

/**
 * Api service for processing server requests using commands
 */
let commandCache = new Map();
class CommandApi {

  static entry = '/api/command/exec';

  static createRequestPayload = (commandName, requestData) => {
    return {
      commandName,
      payload: requestData || {}
    }
  }

  async send(commandName, data) {
    const config = await configPromise;
    const response = await api.post(
      config.apiPath(CommandApi.entry),
      CommandApi.createRequestPayload(commandName, data)
    );

    if (response instanceof AppError) {
      throw response;
    }
    return response.payload;
  }

}

export const commandApi = new CommandApi();
